export default {
    About: 'Home',
    Events: 'Events',
    ProductsShow: 'Show',
    Material: 'Download',
    Participantlogin: 'Competitor Login',
    Judgelogin: 'Judge Login',
    Introduction: 'Introduction',
    EntryInformation: 'Notice',
    Participation: 'Participation',
    Scopeofentriessubmitted: 'Regulation',
    Awardssetting: 'Awards',
    DocumentDownload: 'Download',
    tis:'The registration channel for the China Bicycle e-Bike Design Competition has been closed',
    Contactthetheorganizingcommittee: 'Contact Us',
    Guidanceunit: 'Guidance Unit',
    Organizers: 'Organizers',
    CoOrganizer: 'Co-Organizer',
    Organizer: 'Organizer',
    SupportUnits: 'Support Units',
    Juries: 'Juries',
    SupportMedia: 'Support Media',
    SelectionPurpose: 'Selection Purpose',
    Candidates: 'Candidates',
    Candidatesbody: 'Complete bicycle, electric bicycle, bicycle parts, electric bicycle parts and related supporting products listed in Chinese market or overseas market by the enterprise (individual) independent research and development design, and has achieved mass production in the last three years.',
    Conditions: 'Conditions',
    Conditionsbody: 'The products must also meet the following requirements:\n1.Products successfully developed and marketed in 2020-2022.\n2.New products, or major changes in the upgrade of products.\n3.Clear intellectual property rights, novel product design, reasonable structure, superior performance, advanced and applicable technology.\n4.Have the necessary standards, process procedures, safety procedures, operation procedures, tooling, testing means.\n5.To meet the design requirements, in line with national standards, industry standards or user requirements, the technical level to achieve international, domestic advanced.',
    Costs: 'Costs',
    Costsbody: '1.Entry fee: Free.\n2.All the expenses of transportation, communication, mailing, publicity and product transportation incurred by participants shall be borne by themselves.',
    Reviewprinciple: 'Review Principle',
    Reviewprinciplebody: 'Elements of innovation, Technical content, Low carbon and energy-saving, Market Space, User- Friendly, Cost advantage, Appropriate Aesthetics, Social responsibility.',
    Reviewprocess: 'Review Process',
    Reviewprocessbody: '1.Preliminary assessment: The judging committee will select the shortlisted products from all the participating products according to the standard from June 15th, 2023. The list will be publicized on www.cbda.otobtb.com website and China Bicycle wechat from July 20 to 31, 2023, and receive extensive inquiries and suggestions from all walks of life on the authenticity and innovation of the information of the works and ownership issues.\n2.Public voting online: The shortlisted products will be publicized and voted on by the public in July 20th-31st, 2023.\n3.Review by the committee: In September1st, 2023, the members of the evaluation committee will re-evaluate the shortlisted products and produce the selection results.\n4.Network voting accounts for 10%, and review committee deliberation accounts for 90%; The final judging results will be announced by the presenters at the awards ceremony on December X, 2023.',
    Entryway: 'Entry way',
    Entrywaybody: '1.Enterprise agents recommend themselves.\n2.Recommended by experts from professional institutions.\n3.Each province and city industry bicycle association recommended club recommended professional media recommended',
    Registration: 'Registration',
    Registrationbody: 'From Sep1st 2022 to Feb 28th 2023, the deadline for submission is March 10, 2023.',
    Company: 'Company:',
    Companyplaceholder: 'Please Enter Company Name',
    ProductName: 'Product name:',
    ProductNameplaceholder: 'Please Input The Product Name',
    ProductBrand: 'Product Brand:',
    ProductBrandplaceholder: 'Please enter product brand',
    Producttype: 'Product Type:',
    Producttypeplaceholder: 'Please Enter Product Type',
    Productsize: 'Product Size:',
    Productsizeplaceholder: 'Please Enter Product Size (mm)',
    NetWeight: 'Net Weight:',
    NetWeightplaceholder: 'Please Enter The Net Weight Of The Product (kg)',
    Price: 'Price:',
    Priceplaceholder: 'Please Enter The Product Price (RMB)',
    Mainpicturesofproducts: 'Pictures Of Works (3-6 Real Pictures Or Renderings (300dpi, JPG Format)):',
    Mainpicturesofproductsplaceholder: 'Please Upload The Pictures Of Works',
    Productapplicationscenariopictures: 'Product Application Scenario Pictures:',
    Productapplicationscenariopicturesplaceholder: 'Please Upload A Picture Of The Usage Scene',
    Schematicdiagramofkeypointsofproductdesign: 'Schematic Diagram Of Key Points Of Product Design:',
    Schematicdiagramofkeypointsofproductdesignplaceholder: 'Please Upload Product Design Schematic',
    Videos: 'Works Related Video (Mp4 Format, Duration Within 2 Minutes, Resolution 1280 * 720):',
    Videosplaceholder: 'Please Upload Product Video',
    reVideosplaceholder: 'Re Upload Product Video',
    Producttestingreport: 'Product Testing Report:',
    Producttestingreportplaceholder: 'Please Upload Product Test Report',
    Productdescription: 'Product Description:',
    Productdescriptionplaceholder: 'Please Enter Product Description',
    Designhouse: 'Design House:',
    Designhouseplaceholder: 'Please Enter A Design Company',
    Manufacturingcompany: 'Manufacturing Company:',
    Manufacturingcompanyplaceholder: 'Please Enter Manufacturing Company',
    PatentNumber: 'Patent Number:',
    PatentNumberplaceholder: 'Please Enter The Patent Number',
    Certificateforinventorspatentright: "Certificate For Inventor's Patent Right:",
    Certificateforinventorspatentrightplaceholder: 'Please Upload The Invention Patent Certificate',
    UtilityModelPatent: 'Utility Model Patent:',
    UtilityModelPatentplaceholder: 'Please Upload The Utility Model Patent Certificate',
    DesignPatent: 'Design Patent:',
    DesignPatentplaceholder: 'Please Upload The Design Patent Certificate',
    DescriptionofSpecialFunctions: 'Description Of Special Functions:',
    DescriptionofSpecialFunctionsplaceholder: 'Please Enter A Description Of The Special Function',
    SpecialMaterials: 'Special Materials:',
    SpecialMaterialsplaceholder: 'Please Enter Special Material',
    Specialprocess: 'Special Process:',
    Specialprocessplaceholder: 'Please Enter Special Process',
    OtherInnovationDescriptions: 'Other Innovation Descriptions:',
    OtherInnovationDescriptionsplaceholder: 'Please Enter Another Innovation Description',
    Aerodynamics: 'Aerodynamics:',
    Aerodynamicsplaceholder: 'Please Enter Aerodynamics',
    Ergonomics: 'Ergonomics:',
    Ergonomicsplaceholder: 'Please Enter Ergonomics',
    Lightweightdescription: 'Lightweight Description:',
    Lightweightdescriptionplaceholder: 'Please Enter A Lightweight Description',
    SpecialMaterials: 'Special materials:',
    SpecialMaterialsptionplaceholder: 'Please Enter Special Material',
    Weightcarryingability: 'Weight-carrying Ability:',
    Weightcarryingabilityptionplaceholder: 'Please Enter Load Capacity',
    Convenience: 'Convenience:',
    Convenienceplaceholder: 'Please Enter A Convenience Description',
    Security: 'Security:',
    Securityplaceholder: 'Please Enter A Security Description',
    EnvironmentalPerformance: 'Environmental Performance:',
    EnvironmentalPerformanceplaceholder: 'Please Enter An Environmental Description',
    Adaptabilitytospecialroadconditions: 'Adaptability To Special Road Conditions:',
    Adaptabilitytospecialroadconditionsplaceholder: 'Please Enter Special Road Conditions Adaptability',
    DescriptionofOtherFeatures: 'Description Of Other Features:',
    DescriptionofOtherFeaturesplaceholder: 'Please Enter Another Feature Description',
    Comfort: 'Comfort:',
    Comfortplaceholder: 'Please Enter A Comfort Description',
    SpecialDesign: 'Special Design:',
    SpecialDesignplaceholder: 'Please Enter A Special Design Description',
    informationsubmission: "Submit",
    RightsandObligations: 'Rights And Obligations',
    RightsandObligationsbody: "1.All participants have the same right to participate in the supervision of suggestions, And The Organizing committee has the obligation to listen to suggestions under supervision.\n2.The Participant irrevocably authorizes the Organizing Committee to edit, publish or print the exhibition publicity for all the winning product brands or other participating product brands deemed necessary by the Organizing Committee in a manner deemed appropriate by the Organizing Committee.\n3.All participants shall not request the Organizing committee to return the submitted information of the product brand; The organizer and the Organizing Committee shall not have the right to claim any compensation for consideration, nor shall they have the right to claim any special rights or share any rights and benefits obtained by the Organizing Committee due to the relevant activities.\n4.The Organizing Committee reserves the right not to award any award if no suitable winning product brand is selected\n5.The participant shall bear all the responsibilities for participating in the evaluation by himself. If the product brand of the participant is found not to meet the conditions of the evaluation, the Organizing Committee has the right to cancel the qualification of the participant and take back the prize won by the participant at any stage of the evaluation. The participant shall bear the losses caused to the Organizing Committee.\n6.By participating in this evaluation, the participant shall be deemed to have fully understood and accepted the terms and conditions of these Rules and their interpretation.",
    DisputeSettlement: "Dispute Settlement",
    DisputeSettlementbody: "1.In Case Of Any Dispute Between The Participants, It Shall Be Settled Through Negotiation First. If The Parties cannot resolve the dispute by themselves, the Organizing Committee may mediate in the middle. If the mediation fails, the parties shall seek legal solutions by themselves.\n2.If other parties raise disputes over intellectual property rights of the participating product brands, the participating parties shall handle the disputes by themselves and bear all legal liabilities. If the Organizing Committee is involved in the disputes, all losses caused by the disputes shall be borne by the participating parties.\n3.All activities involved in this selection shall be governed by and interpreted in accordance with the laws and regulations of the People's Republic of China. All disputes arising from the process of solicitation, evaluation, exhibition and publicity shall be settled through friendly negotiation. If negotiation fails, the disputes shall be submitted to the local court of the Organizing Committee for settlement.",
    Validityandinterpretationright: "Validity and interpretation right",
    Validityandinterpretationrightbody: "The host shall have the right to interpret and modify the Rules. The Rules shall take effect on Oct 20, 2022.",
    Completebicycle: 'Organizing Committee Award:',
    Electricbicycle: "Electric bicycle:",
    BicycleElectricbicycleparts: "Bicycle/Electric Bicycle Parts:",
    Download: 'Download',
    ContactUs: 'Contact Us',
    Contact: 'Contact',
    Tel: 'Tel',
    pleaseTel:"Please Input Tel",
    Fax: 'Fax',
    Zipcoad: 'Zip Coad',
    Emailaddress: 'Email Address',
    Address: 'Address',
    ChinaBikeAssociation: "China Bicycle Association",
    GuangzhouMunicipality: 'The People’s Government Of Guangzhou Municipality',
    ChinaNationalLightIndustryCouncil: 'China National Light Industry Council',
    NationalBicycleIndustryInformationCenter: 'National Bicycle Industry Information Center',
    Development: 'OTOBTB（Shanghai）Cultural Development Co., Ltd.',
    CountryRegion: 'Country/Region',
    Account: 'Account',
    Captcha: 'Captcha',
    ObtainCaptcha: 'Obtain Captcha',
    Password: 'Password ',
    ConfirmPassword: 'Confirm Password',
    digipasswordcassensitive: '6-16digit Password, Case Sensitive',
    Change: "Change",
    wonderfulpictures: 'Wonderful Pictures',
    Worksshowandvote: 'Works Show',
    toauditing: 'To Auditing',
    Voting: 'Voting',
    changePassword: 'Change Password',
    Reviewentries: 'Review Entries',
    Reviewprogressofparticipatingproducts: 'Review Progress Of Participating Products',
    personalcenter: 'Personal Center',
    Participantlogin2: 'Competitor Online',
    Judgelogin2: 'Judges Online',
    Forgotpassword: "Forgot Password?",
    Noaccountyet: "No Account Yet?",
    Registernow: "Register Now!",
    accountlogin1: "User Login",
    accountlogin2: "Judge Login",
    login: "Login",
    Productsubmitted: 'Product Submitted',
    Preliminaryreviewpassed: 'Passed The First Trial',
    selectedforthecompetition: "The Oroduct Has Been Selected For The Competition",
    secondsleft: 'Seconds Left',
    Registeranaccount: 'Register An Account',
    Phonenumber: 'Phone Number',
    Phonenumberbody: 'Please Enter Phone Number',
    pleaseenterverificationcode: 'please Enter Verification Code',
    Sendtheverificationcode: 'Send The Verification Code',
    PleaseenterEmail: 'Please Enter E-mail',
    Pleaseenterpassword: "Please Enter Password",
    Pleaseconfirmyourpassword: 'Please confirm Your Password',
    readandaccept: 'Read And Accept',
    RegistrationEntryAgreement: 'Registration/Entry Agreement, Privacy Policy',
    LegalNotices: 'Legal Notices',
    register: 'Register',

    pvai: 'Product Videos And Pictures',
    Functionality: 'Functionality',
    adoptBtn: 'Adopt',
    refuseBtn: 'Refuse',
    loginOut: 'Logout',
    ContestScope:"Contest Scope:",
    DesignCompletionDate:"Design Completion Date:",
    CopyrightRegistration:"Copyright Registration:",
    TimeToMarket:"Time To Market:",
    PatentApplication:"Patent Application:",
    postalAddress:"Postal Address:",
    ContactName:"Contact Name:",
    MobilePhone:"Mobile Phone:",
    job:"Job:",
    fixedTelephone:"Fixed Telephone:",
    email:"Email:",
    pleaseContestScope:"Please Input Contest Scope",
    pleaseDesignCompletionDate:"Please Input design completion date",
    pleaseCopyrightRegistration:"Please copyright registration",
    pleaseTimeToMarket:"Please Input Time To Market",
    pleasePatentApplication:"Please Input Patent Application",
    pleasePostalAddress:"Please Input Postal Address",
    pleaseContactName:"Please Input Contact Name",
    pleaseMobilePhone:"Please Input Mobile Phone",
    pleaseJob:"Please Input Job",
    pleaseFixedTelephone:"Please Input Fixed Telephone",
    pleaseEmail:"Please Input Email",
    companyIntroduction:"Company Introduction Or Personal Introduction:",
    pleaseCompanyIntroduction:"Please Input Company Or Personal Introduction",
    personnelInformation:"Personnel Information:",
    pleasePersonnelInformation:"Please Input Personnel Information",
    name:"Name:",
    pleaseName:"Please Input Name",
    designIntroduction:"DesignIntroduction:",
    pleaseDesignIntroduction:"Describe the design concept, purpose and function of the entries in words, with emphasis on description The creativity, practicality, aesthetic effect, ergonomics, quality, environmental protection and economy of the works are limited to 800 words.",
    yes:"Yes",
    no:"No",
    pleaseChoose:"Please Choose",
    hadPost:"You Already Have An Entry!",
    delete:"Delete",
    add:"Add",
    maxLength:"Max Length",
    pictureLength:"Please Upload 3-6 Pictures",
    files:"Work Presentation (ppt or pdf):",
    clickUp: "Click",
    filesWarn: "Please Upload Work Presentation",
    pleasePersonnelInformation: "Please Fill In The Design Team Information",
    judgeCant:"Judges Do Not Need To Participate",
    videoNoFinish:"Video Do Not Updated Already",
    passed:"passed",
}